import React from "react";
import { ResponsiveContainer, BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Bar } from "recharts";

const TiposEmbalagensChart = ({ data = [], height = 300, color = "#5cb85c" }) => (
  <ResponsiveContainer width="100%" height={height}>
    <BarChart data={data} layout="vertical">
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis type="number" />
      <YAxis type="category" dataKey="name" width={150} />
      <Tooltip />
      <Bar dataKey="value" fill={color} />
    </BarChart>
  </ResponsiveContainer>
);

export default TiposEmbalagensChart;
